import { GuardedRoute } from 'app/interfaces/route';
import { ConnectionCallbackRoutes } from 'modules/platform-linking/connection-callback-routes';

export const CONNECTION_CALLBACK_ROUTES: GuardedRoute[] = [...ConnectionCallbackRoutes];
